<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">

        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Détails du Média</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn color="secondary" depressed  @click="updateThis">Sauvegarder</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container fluid>
                <v-row dense>
                    <v-col cols="12" md="8">
                        <v-list>
                            <v-list-item>
                                <v-text-field label="Titre" v-model="mediaDetails.title" hide-details="auto"></v-text-field>
                            </v-list-item>
                        </v-list>
                        <v-list>
                            <v-list-item>
                                <v-row>
                                    <v-col cols="6">
                                     <v-combobox
                                        v-model="mediaDetails.meta.ref"
                                        :items="referenceItems.values"
                                        :label="referenceItems.libelle"
                                        multiple
                                        dense
                                        hide-details
                                        chips
                                        ></v-combobox>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select
                                        v-model="mediaDetails.meta.type"
                                        :items="typeItems"
                                        item-text="Libelle"
                                        item-value="value"
                                        label="Type"
                                        multiple
                                        dense
                                        hide-details
                                        chips
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select
                                        v-model="mediaDetails.meta.brand"
                                        :items="brandItems"
                                        item-text="Libelle"
                                        item-value="value"
                                        label="Marque"
                                        multiple
                                        dense
                                        hide-details
                                        chips
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select
                                        v-model="mediaDetails.meta.product"
                                        :items="productsItems"
                                        item-text="Libelle"
                                        item-value="value"
                                        label="Produits"
                                        multiple
                                        dense
                                        hide-details
                                        chips
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-combobox
                                        v-model="mediaDetails.meta.utilisation"
                                        :items="utilisationItems.values"
                                        :label="utilisationItems.libelle"
                                        multiple
                                        dense
                                        hide-details
                                        chips
                                        ></v-combobox>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-combobox
                                        v-model="mediaDetails.meta.tags"
                                        :items="tagItems.values"
                                        :label="tagItems.libelle"
                                        multiple
                                        dense
                                        hide-details
                                        chips
                                        ></v-combobox>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-textarea
                                            label="Commentaire"
                                            :value="mediaDetails.meta.comment"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col cols="12" md="4" class="text-center pa-3 side-content"  >
                        <picture>
                            <img :src="this.mediaDetails.thumb+'?option=y500'"  />
                        </picture>
                        <div class="details">
                            <h3>Détail Fichier</h3>
                            <v-row justify="space-around">
                                <p>Type : {{this.mediaDetails.mime}}</p>
                                <p v-if="this.mediaDetails.fileinfo.image">Largeur : {{this.mediaDetails.fileinfo.image.x}}</p>
                                <p v-if="this.mediaDetails.fileinfo.doc">Nombre de pages : {{this.mediaDetails.fileinfo.doc.Pages}}</p>
                            </v-row>
                            <v-row justify="space-around">
                                <p>Poids : {{Math.round(this.mediaDetails.fileinfo.size / 1000)}} ko</p>
                                <p v-if="this.mediaDetails.fileinfo.image">Hauteur : {{this.mediaDetails.fileinfo.image.y}}</p>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            
             
        </v-card>
       
    </v-dialog>
</template>

<script>
    export default {
        name: 'Modal',
        data () {
            return {
                notifications: false,
                sound: true,
                widgets: false,
                mediaToUpdate: {},
            }
        },
        computed: {
            dialog: {
                get () {
                    return this.$store.state.dialog
                },
                set (value) {
                    this.$store.dispatch('setDialog', value)
                }
            },
            mediaDetails: function(){
                return this.$store.state.mediaDetails
            },
            referenceItems: function(){
                return this.$store.state.infosMetas.ref
            },
            nameItems: function(){
                return this.$store.state.infosMetas.name
            },
            typeItems: function(){
                return this.$store.state.listItems.types
            },
            brandItems: function(){
                return this.$store.state.listItems.brand
            },
            productsItems: function(){
                return this.$store.state.listItems.products
            },
            utilisationItems: function(){
                return this.$store.state.infosMetas.utilisation
            },
            tagItems: function(){
                return this.$store.state.infosMetas.tags
            },
            commentItems: function(){
                return this.$store.state.infosMetas.comment
            }
        },
        methods : {
            updateThis(){
                //const mediaToUpdate = Object.assign({}, this.mediaDetails)
                this.$store.dispatch('updateMediaDetails', this.mediaToUpdate).then(() => {
                    this.$store.dispatch('setDialog', false)
                    this.$store.dispatch('updateMediaList', this.mediaToUpdate)
                }) 
            },
        },
        watch : {
            mediaDetails: {
                handler : function(newMedia){
                    this.mediaToUpdate = Object.assign({}, newMedia)
                },
                deep:true
            },
           
        },
        created() {
            
        },
    }
</script>

<style lang="scss">
    .thumb {
        width: auto;
        max-width:500px;
        height:auto;
        max-height:500px;
        border-radius:5px;
    }
    .side-content {
        picture {
            max-width:100%;
            img {
                max-width:100%;
                height:auto;
            }
        }
    }
    .details {
        h3 {
            margin-bottom:10px;
        }
        p {
            margin-bottom:0;
        }
    }
    .generator {
        padding:20px;
        border-radius:20px;
    }
    .mediaGenerated {
        width:100%;
        height:auto;
    }
</style>